import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import FlowGroups from './FlowGroups';

const FlowGroupsBridge = react2angular(FlowGroups, [
  'isMobile',
  'groups',
  'onFlowClick'
]);

export default FlowGroupsBridge;
